import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LMSFollowupForm from "./LMSFollowupForm";
import { fetchLMSFollowupsData } from "../../../../redux/prospect-reducers/prospectSlice";

const LeadFollowup = ({ userInfoData, rowData, isTable, closeModal }) => {
  const dispatch = useDispatch();
  const { lmsFollowups, lmsFollowupsLoading, lmsFollowupsError } = useSelector(
    (state) => state.prospects
  );

  const [allFollowupsDatas, setAllFollowupsDatas] = useState([]);

  const sortedFollowupData =
    allFollowupsDatas?.length > 0
      ? [...allFollowupsDatas].sort(
          (a, b) => b?.follow_up_number - a?.follow_up_number
        )
      : [];

  function getLMSFollowups(filters) {
    dispatch(
      fetchLMSFollowupsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    if (rowData?.lead_id) {
      const sendableFilters = {
        lead_id: rowData?.lead_id,
      };

      getLMSFollowups(sendableFilters);
    }
  }, []);

  useEffect(() => {
    if (
      !lmsFollowupsLoading &&
      !lmsFollowupsError &&
      lmsFollowups?.status &&
      lmsFollowups?.data
    ) {
      setAllFollowupsDatas(lmsFollowups.data);
    } else {
      setAllFollowupsDatas([]);
    }
  }, [lmsFollowupsLoading, lmsFollowups]);

  if (lmsFollowupsLoading) {
    return (
      <div className="lead-v2-cycle-loading">
        <div className="lead-v2-loading-spinner"></div>
        <p>Loading follow-ups...</p>
      </div>
    );
  }

  if (lmsFollowupsError) {
    return (
      <div className="lead-v2-cycle-error">
        <p>Error loading timeline. Please try again.</p>
      </div>
    );
  }

  return (
    <div className="lead-followup-root">
      <div className="lead-followup-card">
        <div className="lead-followup-title">Schedule Follow-up</div>

        <LMSFollowupForm
          userInfoData={userInfoData}
          rowData={rowData}
          allFollowups={allFollowupsDatas}
          callFunction={() => {
            if (rowData?.lead_id) {
              const sendableFilters = {
                lead_id: rowData?.lead_id,
              };

              getLMSFollowups(sendableFilters);
            }
          }}
          followupStage={sortedFollowupData?.[0]?.follow_up_number || 0}
          isTable={isTable}
          closeModal={closeModal}
        />
      </div>

      {/* {!isTable && (
        <div className="lead-followup-card lead-followup-actions">
          <div className="lead-followup-title">Quick Actions</div>
          <button className="lead-followup-action-btn">
            <span className="lead-followup-action-icon">
              <CallIcon />
            </span>
            Log Call
          </button>
          <button className="lead-followup-action-btn lead-followup-action-secondary">
            <span className="lead-followup-action-icon">
              <WhatsAppIcon />
            </span>
            Send WhatsApp
          </button>
          <button className="lead-followup-action-btn lead-followup-action-success">
            <span className="lead-followup-action-icon">
              <TargetIcon />
            </span>
            Mark as Converted
          </button>
          <button className="lead-followup-action-btn lead-followup-action-danger">
            <span className="lead-followup-action-icon">
              <WarningIcon />
            </span>
            Mark as Cold
          </button>
        </div>
      )} */}
    </div>
  );
};

export default LeadFollowup;
